import { FC, Fragment, ReactNode, useEffect, useMemo, useState } from "react";
import {
  App,
  Button,
  Divider,
  Flex,
  Form,
  Modal,
  Row,
  Spin,
  Table,
  Tabs,
  Tag,
  Tooltip,
} from "antd";
import { useTranslation } from "react-i18next";
import SText from "@/styles/SText";
import { CheckOutlined, CloseOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/es/table";
import { dateFormat } from "@/utils/format";
import dayjs from "dayjs";
import {
  addQuotationRequest,
  fetchQuotationRequests,
  handleSelect,
  QuotationRequestInts,
  QuotationRequestsParams,
} from "@/apis/requirement";
import {
  QuotationRequest,
  QuotationRequestSelectedEnum,
  QuotationRequestStatusEnum,
  Requirement,
  RequirementItem,
} from "@/types/requirement";
import { getSupplierName } from "@/utils/supplier";
import RequirementDescChild from "./RequirementDescChild";
import QuotationForm from "@/components/QuotationForm";
import { DescWrap } from "@/pages/Requirement/style";
import refreshIcon from "@/assets/images/common/refresh.svg";
import LazyQuate from "./LazyQuate";
import useRequirementParams from "@/pages/Requirement/hooks/useRequirementParams";
import { PageId } from "@/types/page";
import AddQuotation from "@/pages/Requirement/components/AddQuotation";
import { quotationPurchase } from "@/apis/quotationRequestItem";
import { useSelector } from "react-redux";
import { Org } from "@/types/org";
import { RootState } from "@/store";
import { AcceptStateEnum } from "@/types/purchase";
import { getQuotationPrice, numFormmater } from "@/pages/Requirement/util";

interface QuotationFormProps {
  mrd: number | null;
  requirement?: Requirement;
  detail: RequirementItem;
  onCancel: () => void;
  reOrder?: boolean;
  onReSelect?: (id: string, data: QuotationRequest) => void;
}

enum TabEnum {
  PERSON = "1",
  AUTO = "2",
}

interface HeadDesc {
  key: string;
  label: string;
  children: ReactNode;
}

const QuoteProgressDetail: FC<QuotationFormProps> = ({
  requirement,
  mrd,
  detail,
  onCancel,
  reOrder,
  onReSelect
}) => {
  const { notification } = App.useApp();
  const { t } = useTranslation();
  const { pageId, pageType } = useRequirementParams(true);
  const currentOrg: Org = useSelector((state: RootState) => state.orgReducer.curOrg);


  const [activeTab, setActiveTab] = useState<TabEnum>(TabEnum.PERSON);

  const [dataQuotationRequest_0, setDataQuotationRequest_0] = useState<QuotationRequest[]>([]);   //协助
  const [dataQuotationRequest_1, setDataQuotationRequest_1] = useState<QuotationRequest[]>([]);   //供应商
  const [detailId, setDetailId] = useState<string>("");
  const [isAddData, setIsAddData] = useState<boolean>(false);
  const [selLoading, setSelLoading] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);
  const [qutation, setQutation] = useState<QuotationRequest | null>(null);
  const [purchaseLoading, setPurchaseLoading] = useState<boolean>(false);
  const [purchased, setPurchased] = useState<boolean>(false);
  const [quoDetail, setQuoDetail] = useState<QuotationRequest | null>(null)

  const [reQuo, setReQuo] = useState<boolean>(false);
  const [reQuoDe, setReQuoDe] = useState<QuotationRequest | null>(null);

  useEffect(() => {
    getData();
  }, [detail]);

  useEffect(() => {
    handlePurchasedDis(dataQuotationRequest_0, dataQuotationRequest_1)
  }, [dataQuotationRequest_0, dataQuotationRequest_1])

  const handlePurchasedDis = (d0: QuotationRequest[], d1: QuotationRequest[]) => {
    let flag = false
    if (d0.length > 0) for (let i = 0; i < d0.length; i++) {
      if (d0[i].selected === QuotationRequestSelectedEnum.SELECTED && d0[i].purchaseItem && d0[i].purchaseItem?.order?.acceptState !== AcceptStateEnum.REJECTED) {
        flag = true
        break;
      }
    }
    if (d1.length > 0 && !flag) for (let i = 0; i < d1.length; i++) {
      if (d1[i].purchaseItem && d1[i].purchaseItem?.order?.acceptState !== AcceptStateEnum.REJECTED) {
        flag = true
        break;
      }
    }
    setPurchased(flag)
  }



  const getStatusLabel = (status: QuotationRequestStatusEnum) => {
    return status === QuotationRequestStatusEnum.READ ||
      status === QuotationRequestStatusEnum.UNREAD ? (
      <Tag color="#2db7f5">{t("requirement.unPriced")}</Tag>
    ) : status === QuotationRequestStatusEnum.SUBMITED ? (
      <Tag color="#87d068">{t("requirement.resolved")}</Tag>
    ) : status === QuotationRequestStatusEnum.REJECTED ? (
      <Tag color="#f50">{t("requirement.reject")}</Tag>
    ) : (
      <></>
    );
  };

  // const handlePurchase = (id: string) => {
  //   if (purchaseLoading) return
  //   setPurchaseLoading(true)
  //   quotationPurchase([id], 0, currentOrg?.id || '')
  //     .then(res => {
  //       if (res && res.length > 0) {
  //         notification.success({ placement: 'top', message: t("purchase.addPurSuccessTip") })
  //         setDataQuotationRequest_0(last => last.map(i => ({ ...i, purchaseItem: i.id === id ? res[0].purchaseItem : undefined })))
  //         setDataQuotationRequest_1(last => last.map(i => ({ ...i, purchaseItem: i.id === id ? res[0].purchaseItem : undefined })))
  //       }
  //       else notification.success({ placement: 'top', message: t("purchase.addNoPurSuccess") })
  //     })
  //     .catch(err => {
  //       console.log(err);
  //     })
  //     .finally(() => {
  //       setPurchaseLoading(false)
  //     })
  // }

  // const handlePurPreview = (id: string) => {

  // }

  const tabTableColums: ColumnsType<QuotationRequest> = useMemo(() => {
    return [
      {
        title: t("requirement.supplier"),
        dataIndex: "supplerId",
        width: 120,
        ellipsis: true,
        render: (_, record) => (
          <SText
            text={getSupplierName(record.supplier)}
            style={{ width: "100%" }}
          />
        ),
      },
      {
        title: t("requirement.supplierTime"),
        dataIndex: "mrd",
        render: (_, record) => (
          <SText
            text={
              record?.supplierTime ? dateFormat(dayjs(record.supplierTime)) : ""
            }
            style={{ width: "100%" }}
          />
        ),
      },
      {
        title: t("purchase.purPrice"),
        dataIndex: "price",
        render: (_, record) => {
          const price = getQuotationPrice(record);
          return <SText text={price === null ? "" : numFormmater(price)} style={{ width: "100%" }} />;
        },
      },
      {
        title: t("requirement.mpq"),
        dataIndex: "mpq",
        render: (_, record) => (
          <SText text={record.mpq || ""} style={{ width: "100%" }} />
        ),
      },
      {
        title: t("requirement.days"),
        dataIndex: "days",
        render: (_, record) => (
          <SText
            text={record?.days?.toString() || ""}
            style={{ width: "100%" }}
          />
        ),
      },
      {
        title: t("requirement.status"),
        dataIndex: "status",
        render: (_, record) => getStatusLabel(record.status)
      },
      {
        title: t("requirement.selected"),
        dataIndex: "selected",
        render: (_, record) => {
          if (record.selected === QuotationRequestSelectedEnum.SELECTED) return <CheckOutlined style={{ color: '#87d068' }} />
          else return <CloseOutlined style={{ color: '#f50' }} />
        }
      },
      {
        title: t("purchase.purState"),
        dataIndex: "status",
        render: (_, record) => {
          if (record.purchaseItem) {
            if (record.purchaseItem?.order?.acceptState === null) return <Tag color="blue">{t("purchase.pend")}</Tag>
            if (record.purchaseItem?.order?.acceptState === AcceptStateEnum.RESOLVED) return <Tag color="green">{t("purchase.acceptType")}</Tag>
            if (record.purchaseItem?.order?.acceptState === AcceptStateEnum.REJECTED) return <Tag color="red">{t("purchase.rejectType")}</Tag>
          } else {
            return <Tag>{t('purchase.nilPur')}</Tag>
          }
        }
      },
      {
        title: t("common.opt"),
        hidden: pageId && ![PageId.PUR_NOT_PASS, PageId.PUR_ORDER_PAYED].includes(pageId) && !reOrder,
        width: 120,
        render: (_, record) => {
          if (record.status === QuotationRequestStatusEnum.REJECTED) return null
          else if (record.status === QuotationRequestStatusEnum.SUBMITED) {
            return <Flex gap={6}>
              {(pageId === PageId.PUR_ORDER_PAYED && record.selected !== QuotationRequestSelectedEnum.SELECTED && (!record.purchaseItem || record.purchaseItem.order.acceptState !== AcceptStateEnum.REJECTED)) && <Button disabled={purchased} loading={selLoading} type="link" onClick={() => reSelected(record.id)}>{t('requirement.reSelect')}</Button>}
              {(pageId === PageId.PUR_ORDER_PAYED && record.selected !== QuotationRequestSelectedEnum.SELECTED && record.purchaseItem?.order.acceptState === AcceptStateEnum.REJECTED) && <Button loading={reQuo} type="primary" onClick={() => setReQuoDe(record)}>{t('requirement.rePrice')}</Button>}
              {/* {(pageId === PageId.PUR_ORDER_PAYED && record.selected === QuotationRequestSelectedEnum.SELECTED && record.purchaseItem && record.purchaseItem?.order.acceptState !== AcceptStateEnum.REJECTED) && <Button disabled onClick={() => handlePurPreview(record.id)} >{t('purchase.hasPurOrder')}</Button>} */}
              {/* {
                (pageId === PageId.PUR_NOT_PASS) && <Button type="primary" loading={purchaseLoading} onClick={() => handlePurchase(record.id)} >{t('requirement.purchase')}</Button>
              } */}
              <Button type="link" onClick={() => setQuoDetail(record)}>{t('common.detail')}</Button>
            </Flex>
          } else if (activeTab === TabEnum.AUTO) {
            return <Flex gap={6}>
              <Button onClick={() => setQutation(record)}>
                {t("requirement.lazyQuota")}
              </Button>
              <Button type="link" onClick={() => setQuoDetail(record)}>{t('common.detail')}</Button>
            </Flex>
          } else {
            return <Button onClick={() => setDetailId(record.id)}>
              {t("requirement.requirementHelp")}
            </Button>
          }
        }
      },
      {
        title: t("common.opt"),
        hidden: pageId !== PageId.MC_PASSED || (pageId === PageId.MC_PASSED && activeTab === TabEnum.PERSON),
        width: 120,
        render: (_, record) => <Button type="link" onClick={() => setQuoDetail(record)}>{t('common.detail')}</Button>
      },
      {
        title: t("common.opt"),
        hidden: pageId !== PageId.PUR_OM,
        width: 120,
        render: (_, record) => {
          if (record.status === QuotationRequestStatusEnum.REJECTED) return null
          else if ([QuotationRequestStatusEnum.UNREAD, QuotationRequestStatusEnum.READ].includes(record.status)) {
            return (
              <Button onClick={() => setDetailId(record.id)}>
                {t("requirement.requirementHelp")}
              </Button>
            )
          } else {
            if (record.selected !== QuotationRequestSelectedEnum.SELECTED) {
              if (record.purchaseItem?.order.acceptState === AcceptStateEnum.REJECTED) return (
                <Button loading={reQuo} type="primary" onClick={() => setReQuoDe(record)}>
                  {t('requirement.rePrice')}
                </Button>
              )
              else return (
                <Button disabled={purchased} loading={selLoading} type="link" onClick={() => reSelected(record.id)}>
                  {t('requirement.reSelect')}
                </Button>
              )
            }
            return null;
          }
        }
      },
    ];
  }, [activeTab, pageId, purchaseLoading, purchased]);

  const onRefresh = () => {
    getData();
  };

  const reSelected = (id: string) => {
    setSelLoading(true)
    handleSelect(id)
      .then(res => {
        notification.success({ placement: 'top', message: t('requirement.reSelecteDone') })
        if (activeTab === TabEnum.PERSON) {
          setDataQuotationRequest_0(last => {
            return last.map(item => ({
              ...item,
              selected: item.id === res.id ? QuotationRequestSelectedEnum.SELECTED : QuotationRequestSelectedEnum.UN_SELECTED
            }))
          })
          setDataQuotationRequest_1(last => last.map(item => ({ ...item, selected: QuotationRequestSelectedEnum.UN_SELECTED })))
        } else {
          setDataQuotationRequest_1(last => {
            return last.map(item => ({
              ...item,
              selected: item.id === res.id ? QuotationRequestSelectedEnum.SELECTED : QuotationRequestSelectedEnum.UN_SELECTED
            }))
          })
          setDataQuotationRequest_0(last => last.map(item => ({ ...item, selected: QuotationRequestSelectedEnum.UN_SELECTED })))
        }
        onReSelect && onReSelect(detail.id, res)
      })
      .catch(err => {
        console.log(err);
        notification.error({ placement: 'top', message: t('requirement.reSelecteFail') })

      })
      .finally(() => setSelLoading(false))
  }

  const getData = async () => {
    setLoading(true);
    await fetchQuotationRequests(detail.id, [QuotationRequestInts.MANUAL])
      .then((res) => {
        setDataQuotationRequest_0([...res]);
      })
      .catch((err) => { })

    await fetchQuotationRequests(detail.id, [QuotationRequestInts.AUTO])
      .then((res) => {
        setDataQuotationRequest_1([...res]);
      })
      .catch((err) => { })

    setLoading(false);

  };

  const quotationRequestTable = () => {
    return (
      <Table
        pagination={{ pageSize: 5 }}
        dataSource={activeTab === TabEnum.PERSON ? dataQuotationRequest_0 : dataQuotationRequest_1}
        columns={tabTableColums}
      />
    );
  };

  const getProductDescList: () => HeadDesc[] = () => {
    let list = [
      {
        key: "code",
        label: t("product.code"),
        children: <SText text={detail.product?.code || ""} />,
      },
      {
        key: "name",
        label: t("product.name"),
        children: <SText text={detail.product?.name || ""} />,
      },
      {
        key: "uom",
        label: t("product.uom"),
        children: <SText text={detail.product?.uom || ""} />,
      },
      {
        key: "model",
        label: t("product.brand1"),
        children: <SText text={detail.product?.model || ""} />,
      },
    ];
    return list;
  };

  const tableTabs = [
    {
      key: TabEnum.PERSON,
      label: t("requirement.requirementHelp"),
      children: quotationRequestTable(),
    },
    {
      key: TabEnum.AUTO,
      label: t("requirement.supplierQuote"),
      children: quotationRequestTable(),
    },
  ];

  const getDdlTime = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    return tomorrow.getTime();
  };

  const onSubmit = (values: QuotationRequestsParams) => {
    if (!!!values?.mpq) values.mpq = "";
    let ddl: number | null = null
    if (activeTab === TabEnum.PERSON) ddl = dataQuotationRequest_0 && dataQuotationRequest_0.length > 0 ? dataQuotationRequest_0[0].deadline as number : null
    else ddl = dataQuotationRequest_1 && dataQuotationRequest_1.length > 0 ? dataQuotationRequest_1[0].deadline as number : null
    values.mrd = mrd as number;
    values.ddl = ddl;
    values.deadline = getDdlTime();

    let strs = values.strs || []

    delete values.strs

    addQuotationRequest(detail.id, QuotationRequestStatusEnum.SUBMITED, values, strs)
      .then((res) => {
        setReQuoDe(null)
        getData();
        if (res && res.length === 0)
          notification.error({ placement: 'top', message: t("requirement.addSuppQutoteTip") });
        else notification.success({ placement: 'top', message: t("common.addSuccess") });
      })
      .catch((err) => {
        notification.error({ placement: 'top', message: t("common.addError") });
      })
      .finally(() => setIsAddData(false));
  };

  const lazyQuotaCb = (newQuotation: QuotationRequest | null) => {
    if (newQuotation) {
      setDataQuotationRequest_1(last => {
        return last.map(item => {
          if (item.id === newQuotation.id) return { ...item, deadline: newQuotation.deadline }
          else return { ...item }
        })
      });
    }
    setQutation(null)
    return
  }

  return (
    <Modal
      title={
        <Flex justify="space-between" align="start">
          <div>{t("requirement.qutotationProgress")}</div>
          <Tooltip title={t("common.refresh")}>
            <Button
              type="text"
              onClick={onRefresh}
              style={{ marginRight: 20, marginTop: -2 }}
              icon={<img alt="" src={refreshIcon}></img>}
            ></Button>
          </Tooltip>
        </Flex>
      }
      maskClosable={false}
      open={true}
      onCancel={onCancel}
      footer={false}
      destroyOnClose
      width={800}
    >
      <div style={{ height: '100%' }}>
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 2,
            }}
          >
            <Spin size="large" />
          </div>
        )}
        <Divider style={{ borderBlockStart: "#172B4D" }}>
          {t("product.productInfo")}
        </Divider>
        <DescWrap>
          {getProductDescList().map((item) => (
            <RequirementDescChild
              key={item.key}
              label={item.label}
              children={item.children}
            />
          ))}
        </DescWrap>
        <Divider style={{ borderBlockStart: "#172B4D" }}>
          {t("requirement.requirementInfo")}
        </Divider>
        <Tabs
          onChange={(tab) => setActiveTab(tab as TabEnum)}
          type="card"
          items={tableTabs}
        />
        {((activeTab === TabEnum.PERSON && pageId && [PageId.PUR_NOT_PASS, PageId.MC_PASSED, PageId.PUR_ORDER_PAYED, PageId.PUR_OM].includes(pageId)) || reOrder) && (
          <Row
            justify="center"
            style={{
              marginBottom: "-20px",
              marginTop: dataQuotationRequest_0.length > 0 ? "-20px" : "10px",
            }}
          >
            <Button disabled={purchased}
              icon={<PlusCircleOutlined />}
              type="default"
              onClick={() => {
                setIsAddData(true);
              }}
            >
              {t("requirement.addSuppQutote")}
            </Button>
          </Row>
        )}
        <QuotationForm formKey={"cooperate"} detailId={detailId} onCancel={() => setDetailId("")} onSubmit={onRefresh} onReject={() => { }} />
        <QuotationForm formKey="detail" detailId={quoDetail?.id || ''} onCancel={() => setQuoDetail(null)} onSubmit={() => { }} onReject={() => { }} />
        {reQuoDe && <AddQuotation requirement={requirement} detail={detail} formData={reQuoDe} onCancel={() => setReQuoDe(null)} onSubmit={onSubmit} />}
        {isAddData && <AddQuotation requirement={requirement} detail={detail} onCancel={() => setIsAddData(false)} onSubmit={onSubmit} />}
        {qutation && <LazyQuate quotation={qutation} cb={(newQutation) => lazyQuotaCb(newQutation)} />}
      </div>
    </Modal>
  );
};

export default QuoteProgressDetail;
